import { Injectable } from '@angular/core';
import { STContactEmailServiceBase } from 'scaletech-core';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';
import { StarbaseComponentMessageService } from './starbase-component-message.service';

@Injectable({
  providedIn: 'root'
})
export class ContactEmailService extends STContactEmailServiceBase {

  constructor(sbCmpMsgSvc: StarbaseComponentMessageService, http: HttpClient, webApi: WebApiService) {
    super(sbCmpMsgSvc, http, webApi);
  }
}
